import { useEffect } from "react";

const CartTracking = () => {
  useEffect(() => {
    if (typeof window === "undefined") return;

    // Cumulus / CL Pixel
    const ordNumber = Math.floor(Math.random() * 1e13);
    const sscUrl = `https://trkn.us/pixel/conv/ppt=23632;g=cnvr_1283702_aha_cart;gid=57614;ord=${ordNumber};v=120`;

    const img = document.createElement("img");
    img.src = sscUrl;
    img.alt = "";
    img.width = 1;
    img.height = 1;
    img.style.display = "none";
    document.body.appendChild(img);

    // Cumulus / Basis Pixel
    const ssaPixel = new Image();
    ssaPixel.src = "https://clickserv.sitescout.com/conv/31d785cb794c9778";

    // DV360 via gtag
    if (window.gtag) {
      window.gtag("event", "conversion", {
        allow_custom_scripts: true,
        send_to: "DC-14614498/cart_0/cart_0+standard",
      });
    }

    // Delayed iframe injection (to ensure iframe.contentWindow is available)
    const iframe = document.createElement("iframe");
    iframe.style.cssText = "width: 0; height: 0; border: 0; display: none;";
    document.body.appendChild(iframe);

    const injectPixelScript = () => {
      const doc = iframe.contentWindow?.document;
      if (doc) {
        doc.open();
        doc.write(
          `<body onload="window.location.href='https://pixel-sync.sitescout.com/dmp/asyncPixelSync'"></body>`
        );
        doc.close();
      }
    };

    // Give iframe a moment to mount
    setTimeout(injectPixelScript, 100);

    return () => {
      document.body.removeChild(img);
      document.body.removeChild(iframe);
    };
  }, []);

  return (
    <noscript>
      <img
        src="https://ad.doubleclick.net/ddm/activity/src=14614498;type=cart_0;cat=cart_0;ord=1?"
        width="1"
        height="1"
        alt=""
      />
    </noscript>
  );
};

export default CartTracking;
